var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerritories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65 0C3.41674 0 2.234 0.489909 1.36195 1.36195C0.489909 2.234 0 3.41674 0 4.65V17.05C0 18.2833 0.489909 19.466 1.36195 20.338C2.234 21.2101 3.41674 21.7 4.65 21.7H17.05C18.2833 21.7 19.466 21.2101 20.338 20.338C21.2101 19.466 21.7 18.2833 21.7 17.05V4.65C21.7 3.41674 21.2101 2.234 20.338 1.36195C19.466 0.489909 18.2833 0 17.05 0H4.65ZM6.2 1.55V20.15H4.65C3.82783 20.15 3.03933 19.8234 2.45797 19.242C1.87661 18.6607 1.55 17.8722 1.55 17.05V4.65C1.55 3.82783 1.87661 3.03933 2.45797 2.45797C3.03933 1.87661 3.82783 1.55 4.65 1.55H6.2ZM7.75 20.15V15.5H20.15V17.05C20.15 17.8722 19.8234 18.6607 19.242 19.242C18.6607 19.8234 17.8722 20.15 17.05 20.15H7.75ZM20.15 13.95H7.75V1.55H17.05C17.8722 1.55 18.6607 1.87661 19.242 2.45797C19.8234 3.03933 20.15 3.82783 20.15 4.65V13.95Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritories);
export default __webpack_public_path__ + "static/media/territories.0f01ea96491651014707dc45edb0435b.svg";
export { ForwardRef as ReactComponent };